var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
const PlainLink = styled.a({
    color: "inherit",
    textDecoration: "none",
});
/**
 * Overrideable link component.
 * - If `Component` is provided, renders as `Component`
 * - else, if `theme.custom.LinkAdapter` is provided, renders as `theme.custom.LinkAdapter`
 * - else, renders as `a` tag
 */
const LinkAdapter = React.forwardRef(function LinkAdapter(_a, ref) {
    var { Component } = _a, props = __rest(_a, ["Component"]);
    const theme = useTheme();
    const LinkComponent = Component !== null && Component !== void 0 ? Component : theme.custom.LinkAdapter;
    return React.createElement(PlainLink, Object.assign({ as: LinkComponent, ref: ref }, props));
});
export { LinkAdapter };
